export function validateMinLength(minLength: number, message: string) {
	return {
		minLength: {
			value: minLength,
			message,
		},
	};
}
